import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFolders20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconFolders20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M9.623 1a2 2 0 0 1 1.532.714L13.075 4H16.5A2.5 2.5 0 0 1 19 6.5v5a2.5 2.5 0 0 1-2.5 2.5H16v2.5a2.5 2.5 0 0 1-2.5 2.5h-10A2.5 2.5 0 0 1 1 16.5v-9a2 2 0 0 1 2-2h1V3a2 2 0 0 1 2-2zM2.5 16.5a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V11a1 1 0 0 0-1-1h-11zm4.123-11a2 2 0 0 1 1.532.714l1.92 2.286H13.5A2.5 2.5 0 0 1 16 11v1.5h.5a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1zM3 7a.5.5 0 0 0-.5.5v1h5.615l-1.11-1.321A.5.5 0 0 0 6.624 7zm3-4.5a.5.5 0 0 0-.5.5v1h5.615l-1.11-1.321a.5.5 0 0 0-.382-.179z"
            />
        </svg>
    );
}
export default memo(IconFolders20);
